import type { Distance, Rectangle } from "@pdfking/math"
import { Round } from "@pdfking/math"
import { CM } from "@pdfking/quantity"

/** A machine size as its division names it: whole centimetres, short side
 * first. */
export const format_division_machine_size = (size: Rectangle<Distance>): string => {
  const w = Round(Round(size.width) / Round(CM(1)))
  const h = Round(Round(size.height) / Round(CM(1)))
  const [a, b] = w <= h ? [w, h] : [h, w]
  return `${a}x${b}`
}
